import type { DirectDealsItemDetails } from '@openx/types/directDeals.ts';
import { createContext, useContext } from 'react';

export type DirectDealsPublisherDetailsState = {
  details: DirectDealsItemDetails | null;
};

const directDealsPublisherDetailsInitialState: DirectDealsPublisherDetailsState = {
  details: null,
};

export const DirectDealsPublisherDetailsContext = createContext<DirectDealsPublisherDetailsState>(
  directDealsPublisherDetailsInitialState
);

export const useDirectDealsPublisherDetails = () => {
  const { details } = useContext(DirectDealsPublisherDetailsContext);

  return details;
};
